export function tagCreatedBuilder(data) {
  return {
    refTag: data?.refTag
  };
}
